import React, {useContext, useEffect, useRef, useState} from 'react';
import './UserRow.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {AdminContext} from '../../contexts/adminContext';
import {constructClassNames} from "../../helpers/helpers";

const UserRow = ({user, openEditUserModal, refreshUserList, rolesOptions, openDeleteUserModal, openChangePasswordModal}) => {
  const { t } = useContext(I18nContext);
  const [showMeatballOptions, setShowMeatballOptions] = useState(false);

  const useOutsideAlerter = ref => {
    useEffect(() => {
      const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowMeatballOptions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const selectRef = useRef(null);
  useOutsideAlerter(selectRef);

  const toggleShowMeatballOptions = () => {
    setShowMeatballOptions(!showMeatballOptions);
  };

  const handleEditUserClick = () => {
    openEditUserModal(user);
    toggleShowMeatballOptions();
    refreshUserList();
  };
  const handleDeleteUserClick = async () => {
    openDeleteUserModal(user)
    toggleShowMeatballOptions();
  };

  const handleChangePasswordClick = async () => {
    openChangePasswordModal(user);
    toggleShowMeatballOptions();
  };

  return (
    <div className='UserRow'>
      <div className='rowItemMeatball' onClick={toggleShowMeatballOptions} ref={selectRef}>
        <div className='meatballDot' />
        <div className='meatballDot' />
        <div className='meatballDot' />
      </div>
      <div className='details'>
        <div className='rowItem'>
          <div className='mobileLabel'>
            {t('e-mail')}:
          </div>
          {user.email}
        </div>
        <div className='rowItem'>
          <div className='mobileLabel'>
            {t('first name')}:
          </div>
          {user.firstName}
        </div>
        <div className='rowItem'>
          <div className='mobileLabel'>
            {t('last name')}:
          </div>
          {user.lastName}
        </div>
        <div className='rowItem'>
          <div className='mobileLabel'>
            {t('role')}:
          </div>
          {rolesOptions.find(x => x.id === user.role).label}
        </div>
      </div>
      {!!showMeatballOptions && (
        <div className='meatballOptions' ref={selectRef}>
          <div className='meatballOption' onClick={handleEditUserClick}>{t('edit')}</div>
          <div className='meatballOption' onClick={handleDeleteUserClick}>{t('delete')}</div>
          <div className='meatballOption' onClick={handleChangePasswordClick}>{t('change password')}</div>
        </div>
      )}
    </div>
  );
};

export default UserRow;
